const items = document.querySelectorAll(".accordion__item");

function isMobile() {
  return window.innerWidth <= 768; 
}

if (isMobile()) {
  items.forEach((item) => {
    const desc = item.querySelector(".accordion__description");
    const icon = item.querySelector("svg");
    desc.style.maxHeight = "0";
    item.classList.remove("active");
    icon.classList.remove("rotate-90");
  });
}

items.forEach((item) => {
  const description = item.querySelector(".accordion__description");
  const icon = item.querySelector("svg");

  if (!isMobile() && item.classList.contains("active")) {
    description.style.maxHeight = description.scrollHeight + "px";
    icon.classList.add("rotate-90");
  }
  
  item.addEventListener("click", (e) => {

    if (e.target.closest("a")) {
      return;
    }

    const isCurrentlyOpen = item.classList.contains("active");
    
    if (isMobile()) {
      items.forEach((other) => {
        const otherDesc = other.querySelector(".accordion__description");
        const otherIcon = other.querySelector("svg");
        otherDesc.style.maxHeight = "0";
        other.classList.remove("active");
        otherIcon.classList.remove("rotate-90");
      });
      
      if (!isCurrentlyOpen) {
        description.style.maxHeight = description.scrollHeight + "px";
        icon.classList.add("rotate-90");
        item.classList.add("active");
      }
    } else {
      if (isCurrentlyOpen) {
        description.style.maxHeight = "0";
        icon.classList.remove("rotate-90");
        item.classList.remove("active");
      } else {
        description.style.maxHeight = description.scrollHeight + "px";
        icon.classList.add("rotate-90");
        item.classList.add("active");
      }
    }
  });
});

window.addEventListener("resize", () => {
  if (!isMobile()) {
    // desktop: keep active ones open
    items.forEach((item) => {
      const desc = item.querySelector(".accordion__description");
      if (item.classList.contains("active")) {
        desc.style.maxHeight = desc.scrollHeight + "px";
      }
    });
  } else {
    let opened = false;
    items.forEach((item) => {
      const desc = item.querySelector(".accordion__description");
      const icon = item.querySelector("svg");
      if (item.classList.contains("active")) {
        if (!opened) {
          desc.style.maxHeight = desc.scrollHeight + "px";
          icon.classList.add("rotate-90");
          opened = true;
        } else {
          desc.style.maxHeight = "0";
          item.classList.remove("active");
          icon.classList.remove("rotate-90");
        }
      } else {
        desc.style.maxHeight = "0";
        icon.classList.remove("rotate-90");
      }
    });
  }
});
